import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';
import ExoForm from '../../../exo/ExoForm';
import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../../api/api';
import { useState } from 'react';

const NewTextBlock = ({
  startData,
  onCreate,
  onClose,
  onFeedback,
  onDelete,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const [isLoading, setIsLoading] = useState(false);

  const types = [
    'offer_company',
    'offer_contact',
    'offer_mail_company',
    'offer_mail_contact',
    'order_company',
    'order_contact',
    'order_mail_company',
    'order_mail_contact',
    'invoice_company',
    'invoice_contact',
    'invoice_mail_company',
    'invoice_mail_contact',
    'partial_invoice_company',
    'partial_invoice_contact',
    'partial_invoice_mail_company',
    'partial_invoice_mail_contact',
    'contract_company',
    'contract_contact',
    'contract_mail_company',
    'contract_mail_contact',
    'employee_contract',
    'employee_contract_mail',
    'recurring_invoice_company',
    'recurring_invoice_mail_company',
    'recurring_invoice_contact',
    'recurring_invoice_mail_contact',
    'timesheet',
    '1_payment_reminder_mail_company',
    '2_payment_reminder_mail_company',
    '3_payment_reminder_mail_company',
    '1_payment_reminder_mail_contact',
    '2_payment_reminder_mail_contact',
    '3_payment_reminder_mail_contact',
    '1_payment_reminder_company',
    '2_payment_reminder_company',
    '3_payment_reminder_company',
    '1_payment_reminder_contact',
    '2_payment_reminder_contact',
    '3_payment_reminder_contact',
    'default_mail',
    'personnel_questionnaire',
    'mail',
    'letter_company',
    'letter_contact',
    'letter_mail_company',
    'letter_mail_contact',
    'delivery_note_company',
    'delivery_note_contact',
    'sales_object_access_point',
    'sales_object_access_level_reminder_mail',
    'sales_object_access_point_mail',
    'sales_object_access_point_seller_confirmation_mail_company',
    'sales_object_access_point_seller_confirmation_mail_contact',
    'contact_form_mail_company',
    'contact_form_mail_contact',
    'hoai_calculation',
    'travel_expense_reimbursement',
    'imap_email',
  ];

  const options = types.map((type) => {
    return { label: type, value: type };
  });

  const fields = [
    {
      label: t('Name'),
      type: 'text',
      key: 'label',
    },
    {
      label: t('Template Types'),
      type: 'customMultiSelect',
      key: 'types',
      options,
    },
  ];

  function handleSubmit(data) {
    const reqData = {
      ...data,
      key: data?.key ? undefined : `{{key=${toKebabCase(data.label)}}}`,
    };

    DBRequest({
      config,
      path: data.id ? `template-blocks/${data.id}` : `template-blocks`,
      method: data.id ? API_PATCH(reqData) : API_POST(reqData),
      onResponse: onCreate,
      onLoading: setIsLoading,
      onFeedback,
    });
  }

  function toKebabCase(str) {
    return str
      .trim() // remove leading/trailing spaces
      .toLowerCase() // convert to lowercase
      .replace(/[^a-z0-9\s]/g, '') // remove special characters (optional)
      .replace(/\s+/g, '-'); // replace spaces with hyphens
  }

  return (
    <ExoForm
      startDataCollection={startData}
      fields={fields}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      onCancel={onClose}
      noDifferences
      onDelete={onDelete}
      header={
        startData && startData.value
          ? startData.id
            ? t('Edit')
            : t('Copy')
          : t('Create')
      }
    />
  );
};

export default NewTextBlock;
